export default __webpack_public_path__ + "static/Corporate-15f9868d00780ec32461e402b9f750f6.webp";